import React, { useState, useEffect, FC } from 'react';
import Search from '@ingka/search';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/search/dist/style.css';
import '@ingka/focus/dist/style.css';

interface GlobalSearchProps {
  queries?: string;
  setQuery?: (value: string) => void;
  onSearch: (query: string) => void;
  tabChange: (tab: any) => void;
  tabChanged: boolean;
  setTabChanged: (changed: boolean) => void;
}

const GlobalSearch: FC<GlobalSearchProps> = ({
  queries,
  setQuery,
  onSearch,
  tabChange,
  tabChanged,
  setTabChanged,
}) => {
  const [inputValue, setInputValue] = useState(queries || '');
  useEffect(() => {
    if (!tabChanged) {
      setInputValue(queries || '');
    }
  }, [queries, tabChanged]);

  useEffect(() => {
    if (tabChanged) {
      setInputValue('');
      setQuery?.('');
      onSearch('');
      setTabChanged(false);
    }
  }, [tabChanged]);

  const handleSearch = () => {
    setQuery?.(inputValue);
    onSearch(inputValue);
  };

  const handleClear = () => {
    setInputValue('');
    setQuery?.('');
    onSearch('');
  };

  return (
    <div>
      <Search
        ariaLabel="Search for supplier name,ref number and commodity."
        clearBtnText="Clear search field"
        id="search"
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Search"
        submitBtnText="Submit"
        onSearch={handleSearch}
        onClear={handleClear}
        value={inputValue}
      />
    </div>
  );
};

export default GlobalSearch;
